import { useTranslation } from "react-i18next";
import { Badge, BadgeType } from "@components/new/Badge";
import MenuItem from '@components/new/MenuItem';
import { ICampaigns } from "@api/apiClient/sellers";

const StoresSelectItem = ({ item, isSelected }: { item: ICampaigns, isSelected?: boolean }) => {
  const { t } = useTranslation();

  return (
    <MenuItem
      title={item.name}
      description={false ? (t('storesPage.addShopModal.parcelsRegistered')) : undefined}
      active={isSelected}
      rightDecoration={item.placementType === "Fbs" ? (
        <Badge type={BadgeType.PURPLE}>
          FBS
        </Badge>
      ) : (item.placementType === "Fby" ? (
        <Badge type={BadgeType.PRIMARY}>
          FBP
        </Badge>
      ): null)}
      stretch
    />
  )
}

export default StoresSelectItem;
